import './AktifSayiKart.css';

const AktifSayiKart = ({ label, value, icon = 'fas fa-store' }) => (
  <div className="aktif-sayi-kart">
    <span className="aktif-sayi-kart__icon" aria-hidden="true">
      <i className={icon} />
    </span>
    <span className="aktif-sayi-kart__body">
      <span className="aktif-sayi-kart__label">{label}</span>
      <span className="aktif-sayi-kart__value">{value == null ? '—' : value}</span>
    </span>
  </div>
);

export default AktifSayiKart;
